<template>
  <div class="v-health-education">
    <sheet v-if="route.name === 'health-education'">

       <div class="wrap wrap__margin-top">
        <!-- <div class="to-detail-page-wrap"> -->
          <ul class="to-detail-page-list">
            <li class="to-detail-page-list__item" v-for="data of healthEducationDetailPage" :key="data.title">
              <div class="to-detail-page-list__item__box">
                <to-detail-page :data="data" />
              </div>
            </li>
          </ul>
        <!-- </div> -->
      </div>
    </sheet>

    <router-view />

  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import ToDetailPage from '@/components/Global/ToDetailPage.vue';

export default defineComponent({
  name: 'HealthEducation',
  components: {

    ToDetailPage,
    // Accordion,
  },
  setup() {
    const route = useRoute();
    const healthEducationDetailPage = [
      {
        title: '高危險妊娠與安胎',
        route: {
          // name: 'pregnant-risk-and-safety',
          path: '/resources/health-education/pregnant-risk-and-safety',
        },
      },
      {
        title: '早產相關疾病與衛教',
        route: {
          name: 'diseases',
        },
      },
      {
        title: '極低出生體重追蹤檢查',
        route: {
          name: 'low-weight-checking',
        },
      },
      {
        title: '早產兒社會福利資源',
        route: {
          name: 'social-welfare',
        },
      },
    ];

    return {
      healthEducationDetailPage,
      route,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/share/toDetailPage';

.wrap {
  // margin-top: 110px;

  &__margin-top {
    margin-top: 50px;
  }
}

</style>
